import React from "react"
import { User } from "../../ZeefTypes"

interface UserInfoProps {
  user: User | null
  isLoading: boolean
  isConnected: boolean
  isEditing: boolean
  editingUsername: string
  onUsernameClick: () => void
  onUsernameChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  onUsernameKeyPress: (event: React.KeyboardEvent<HTMLInputElement>) => void
  onSaveUsername: () => void
  onCancelUsername: () => void
  isUpdating: boolean
}

const UserInfo: React.FC<UserInfoProps> = ({
  user,
  isLoading,
  isConnected,
  isEditing,
  editingUsername,
  onUsernameClick,
  onUsernameChange,
  onUsernameKeyPress,
  onSaveUsername,
  onCancelUsername,
  isUpdating,
}) => {
  if (isLoading) {
    return <div className="user-info loading">Loading user info...</div>
  }

  if (!user) {
    return <div className="user-info error">Unable to load user information</div>
  }

  return (
    <div className="user-info">
      <div className="user-avatar">{user.username.substring(0, 2).toUpperCase()}</div>
      <div className="user-details">
        {isEditing ? (
          <div className="user-name-edit">
            <input
              type="text"
              value={editingUsername}
              onChange={onUsernameChange}
              onKeyDown={onUsernameKeyPress}
              onBlur={onSaveUsername}
              className="form-control username-input"
              disabled={isUpdating}
              autoFocus
            />
            <div className="edit-buttons">
              <button className="save-btn" onClick={onSaveUsername} disabled={isUpdating}>
                {isUpdating ? "..." : "✓"}
              </button>
              <button className="cancel-btn" onClick={onCancelUsername} disabled={isUpdating}>
                ✕
              </button>
            </div>
          </div>
        ) : (
          <div className="user-name clickable" onClick={onUsernameClick} title="Click to edit username">
            {user.username}
          </div>
        )}
        <div className="user-email">{user.email}</div>
      </div>
      <div className={`connection-status ${isConnected ? "connected" : "disconnected"}`}>
        <span className="status-indicator"></span>
        {isConnected ? "Connected" : "Disconnected"}
      </div>
    </div>
  )
}

export default UserInfo
